import React from 'react';
import { WorkTicketDto } from 'src/api/FiretrolApiClient';
import { Header } from 'src/design/organisms/Header';
import { useWorkTickets } from 'src/api/queries/workTickets/useWorkTickets';
import { useJobs } from 'src/hooks/useJobs';
import { TicketsTable } from './TicketsTable';

const EMPTY_TICKETS: WorkTicketDto[] = [];

export const Tickets: React.FC = () => {
  const { selectedJob } = useJobs();
  const { data: tickets = EMPTY_TICKETS, isLoading } = useWorkTickets(
    selectedJob?.id,
  );

  if (!selectedJob) {
    return null;
  }

  return (
    <>
      <Header
        breadcrumbProps={{
          items: [
            { text: 'Jobs', href: '/jobs' },
            {
              text: `${selectedJob.name} - ${selectedJob.jobNumber}`,
              href: `/jobs/${selectedJob.id}/summary`,
            },
            { text: 'Work Tickets' },
          ],
        }}
        title="Work Tickets"
        helpText="Manage work tickets for this job to track issues, requests, and tasks."
      />

      <TicketsTable tickets={tickets} loading={isLoading} />
    </>
  );
};
